import LedgerState from "@/models/Accounts/LendingAccounts/Ledgers/LedgerState";

export default (val: LedgerState) => {
    let returnVal = "Undefined";
    switch (val) {
        case LedgerState.Active:
            returnVal = "Active"
            break;
        case LedgerState.Closed:
            returnVal = "Closed"
            break;
    }
    return returnVal;
}